import { withProps } from 'recompose';
import config from '../../config';

export default withProps({
  urlPattern: config.urlPatterns.giftCard,
});



// WEBPACK FOOTER //
// ./src/app/hoc/WithGiftCardUrlPattern.js